import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const WISContactSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    warehouseSize: '',
    currentChallenges: '',
    demoPreference: 'online'
  });

  const warehouseSizes = [
    { value: 'small', label: { en: 'Small (< 10,000 sq ft)', hi: 'छोटा (< 10,000 वर्ग फीट)' } },
    { value: 'medium', label: { en: 'Medium (10,000 - 50,000 sq ft)', hi: 'मध्यम (10,000 - 50,000 वर्ग फीट)' } },
    { value: 'large', label: { en: 'Large (50,000+ sq ft)', hi: 'बड़ा (50,000+ वर्ग फीट)' } }
  ];

  const challenges = [
    { value: 'inventory-accuracy', label: { en: 'Inventory Accuracy Issues', hi: 'इन्वेंटरी सटीकता समस्याएं' } },
    { value: 'material-tracking', label: { en: 'Material Tracking Difficulties', hi: 'मैटेरियल ट्रैकिंग कठिनाइयां' } },
    { value: 'order-fulfillment', label: { en: 'Slow Order Fulfillment', hi: 'धीमी ऑर्डर पूर्ति' } },
    { value: 'layout-optimization', label: { en: 'Poor Space Utilization', hi: 'खराब स्थान उपयोग' } },
    { value: 'cost-control', label: { en: 'High Carrying Costs', hi: 'उच्च कैरिंग लागत' } }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('WIS Demo Request:', formData);
    // Show success message or redirect
    alert(currentLanguage === 'en' ?'Demo request submitted! Our WIS specialist will contact you within 24 hours.' :'डेमो अनुरोध सबमिट हो गया! हमारा WIS विशेषज्ञ 24 घंटे के भीतर आपसे संपर्क करेगा।'
    );
  };

  const t = (text) => text[currentLanguage] || text.en;

  return (
    <section id="wis-demo-request" className="py-20 bg-gradient-to-b from-surface-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">
            {currentLanguage === 'en' ?'Schedule Your WIS Demo' :'अपना WIS डेमो शेड्यूल करें'
            }
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            {currentLanguage === 'en' ?'See how WIS can transform your warehouse operations. Our experts will customize the demo based on your specific needs and challenges.' :'देखें कि WIS आपके वेयरहाउस संचालन को कैसे बदल सकता है। हमारे विशेषज्ञ आपकी विशिष्ट आवश्यकताओं और चुनौतियों के आधार पर डेमो को अनुकूलित करेंगे।'
            }
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Demo Request Form */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-border">
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-primary mb-4">
                {currentLanguage === 'en' ? 'Request Your Demo' : 'अपना डेमो अनुरोध करें'}
              </h3>
              <p className="text-text-secondary">
                {currentLanguage === 'en' ?'Fill out the form below and our WIS specialist will contact you within 24 hours' :'नीचे दिया गया फॉर्म भरें और हमारा WIS विशेषज्ञ 24 घंटे के भीतर आपसे संपर्क करेगा'
                }
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Basic Information */}
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-text-secondary mb-2">
                    {currentLanguage === 'en' ? 'Full Name *' : 'पूरा नाम *'}
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder={currentLanguage === 'en' ? 'Enter your name' : 'अपना नाम दर्ज करें'}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-text-secondary mb-2">
                    {currentLanguage === 'en' ? 'Email Address *' : 'ईमेल पता *'}
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder={currentLanguage === 'en' ? 'Enter your email' : 'अपना ईमेल दर्ज करें'}
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-text-secondary mb-2">
                    {currentLanguage === 'en' ? 'Phone Number *' : 'फोन नंबर *'}
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder={currentLanguage === 'en' ? 'Enter your phone' : 'अपना फोन दर्ज करें'}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-text-secondary mb-2">
                    {currentLanguage === 'en' ? 'Company Name *' : 'कंपनी का नाम *'}
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder={currentLanguage === 'en' ? 'Enter company name' : 'कंपनी का नाम दर्ज करें'}
                  />
                </div>
              </div>

              {/* Warehouse Size */}
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  {currentLanguage === 'en' ? 'Warehouse Size' : 'वेयरहाउस आकार'}
                </label>
                <select
                  name="warehouseSize"
                  value={formData.warehouseSize}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                >
                  <option value="">
                    {currentLanguage === 'en' ? 'Select warehouse size' : 'वेयरहाउस आकार चुनें'}
                  </option>
                  {warehouseSizes.map((size) => (
                    <option key={size.value} value={size.value}>
                      {t(size.label)}
                    </option>
                  ))}
                </select>
              </div>

              {/* Current Challenges */}
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  {currentLanguage === 'en' ? 'Current Challenges' : 'वर्तमान चुनौतियां'}
                </label>
                <select
                  name="currentChallenges"
                  value={formData.currentChallenges}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                >
                  <option value="">
                    {currentLanguage === 'en' ? 'Select primary challenge' : 'प्राथमिक चुनौती चुनें'}
                  </option>
                  {challenges.map((challenge) => (
                    <option key={challenge.value} value={challenge.value}>
                      {t(challenge.label)}
                    </option>
                  ))}
                </select>
              </div>

              {/* Demo Preference */}
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  {currentLanguage === 'en' ? 'Demo Preference' : 'डेमो वरीयता'}
                </label>
                <div className="flex space-x-4">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="demoPreference"
                      value="online"
                      checked={formData.demoPreference === 'online'}
                      onChange={handleInputChange}
                      className="mr-2"
                    />
                    <span className="text-sm">
                      {currentLanguage === 'en' ? 'Online Demo' : 'ऑनलाइन डेमो'}
                    </span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="demoPreference"
                      value="onsite"
                      checked={formData.demoPreference === 'onsite'}
                      onChange={handleInputChange}
                      className="mr-2"
                    />
                    <span className="text-sm">
                      {currentLanguage === 'en' ? 'On-site Demo' : 'ऑन-साइट डेमो'}
                    </span>
                  </label>
                </div>
              </div>

              {/* Submit Button */}
              <Button
                type="submit"
                variant="primary"
                size="lg"
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
                iconName="Calendar"
                iconPosition="left"
              >
                {currentLanguage === 'en' ? 'Schedule WIS Demo' : 'WIS डेमो शेड्यूल करें'}
              </Button>
            </form>
          </div>

          {/* Contact Information & Demo Benefits */}
          <div className="space-y-8">
            {/* Contact Info */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8">
              <h3 className="text-xl font-semibold text-primary mb-6">
                {currentLanguage === 'en' ? 'Contact Our WIS Experts' : 'हमारे WIS विशेषज्ञों से संपर्क करें'}
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <Icon name="Phone" size={20} color="var(--color-primary)" />
                  <div>
                    <p className="font-medium text-primary">+91 9876543210</p>
                    <p className="text-sm text-text-secondary">
                      {currentLanguage === 'en' ? 'Direct WIS Helpline' : 'सीधी WIS हेल्पलाइन'}
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <Icon name="Mail" size={20} color="var(--color-primary)" />
                  <div>
                    <p className="font-medium text-primary">wis@alumerp.com</p>
                    <p className="text-sm text-text-secondary">
                      {currentLanguage === 'en' ? 'WIS Support Team' : 'WIS सपोर्ट टीम'}
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <Icon name="Clock" size={20} color="var(--color-primary)" />
                  <div>
                    <p className="font-medium text-primary">24/7 Support</p>
                    <p className="text-sm text-text-secondary">
                      {currentLanguage === 'en' ? 'Always available for urgent issues' : 'जरूरी मुद्दों के लिए हमेशा उपलब्ध'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Demo Benefits */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-border">
              <h3 className="text-xl font-semibold text-primary mb-6">
                {currentLanguage === 'en' ? 'What You\'ll See in the Demo' : 'डेमो में आप क्या देखेंगे'}
              </h3>

              <div className="space-y-4">
                {[
                  {
                    icon: "Package",
                    title: {
                      en: "Live Inventory Tracking",
                      hi: "लाइव इन्वेंटरी ट्रैकिंग"
                    },
                    description: {
                      en: "Real-time material movement and location tracking",
                      hi: "रियल-टाइम मैटेरियल मूवमेंट और लोकेशन ट्रैकिंग"
                    }
                  },
                  {
                    icon: "BarChart",
                    title: {
                      en: "Warehouse Analytics",
                      hi: "वेयरहाउस एनालिटिक्स"
                    },
                    description: {
                      en: "Performance dashboards and optimization reports",
                      hi: "प्रदर्शन डैशबोर्ड और अनुकूलन रिपोर्ट"
                    }
                  },
                  {
                    icon: "Smartphone",
                    title: {
                      en: "Mobile Interface",
                      hi: "मोबाइल इंटरफेस"
                    },
                    description: {
                      en: "Touch-friendly mobile app for warehouse staff",
                      hi: "वेयरहाउस स्टाफ के लिए टच-फ्रेंडली मोबाइल ऐप"
                    }
                  },
                  {
                    icon: "Zap",
                    title: {
                      en: "Automation Features",
                      hi: "स्वचालन सुविधाएं"
                    },
                    description: {
                      en: "Automated alerts and reorder point management",
                      hi: "स्वचालित अलर्ट और रीऑर्डर पॉइंट प्रबंधन"
                    }
                  }
                ].map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                      <Icon name={benefit.icon} size={16} color="var(--color-primary)" />
                    </div>
                    <div>
                      <h4 className="font-medium text-primary">{t(benefit.title)}</h4>
                      <p className="text-sm text-text-secondary">{t(benefit.description)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WISContactSection;